module.exports = __webpack_public_path__ + "static/media/plusIconPic.1e9d3bd4.svg";